module.exports = __webpack_public_path__ + "img/my-scenarios.cdf34d63.svg";